(function () {
  'use strict';
  var source = 'teampracticegear.com';
  function emit(event, properties) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: event, source: source, occurred_at: new Date().toISOString(), properties: properties || {} });
  }
  window.TPGRevenue = {
    emit: emit,
    catalog: function () { return window.TPGCanonicalCatalog || []; },
    renderProducts: function (target, products) {
      if (!target || !Array.isArray(products)) return;
      target.dispatchEvent(new CustomEvent('tpg:catalog-ready', { detail: { products: products, source: source } }));
    },
    submitQuote: function (request) {
      emit('revenue_quote_request', { form_id: request.formId || 'unknown', product_ids: (request.items || []).map(function (item) { return item.productId; }), tier_selection: request.tierSelection || null, package_id: request.packageId || null, quote_value: request.quoteValue || null });
      return { source: source, customer: request.customer, items: request.items || [], packageId: request.packageId || null, tierSelection: request.tierSelection || null, notes: request.notes || '' };
    }
  };
  document.addEventListener('click', function (event) {
    var link = event.target.closest('a'); if (!link) return;
    if (link.href.startsWith('tel:')) emit('revenue_phone_click', { page: location.pathname });
    if (link.href.startsWith('mailto:')) emit('revenue_email_click', { page: location.pathname });
    if (link.hasAttribute('download')) emit('revenue_download', { asset_id: link.getAttribute('href') });
  });
  document.querySelectorAll('[data-revenue-products]').forEach(function (element) { element.setAttribute('aria-busy', 'false'); });
  emit('revenue_catalog_ready', { product_count: (window.TPGCanonicalCatalog || []).length, catalog_version: 'Catalog-v1.0' });
}());
